import React, { Component } from 'react';

import './Footer.css';

class Footer extends Component {
    render() {
        const year = new Date().getFullYear()

        return (
            <div className="footer footer-lg footer-md footer-sm footer-xs">
                <div className="col-md-12 text-center">
                    <p>
                        <span>© TROI Studio {year}</span>
                    </p>
                </div>

                <div className="clearfix"></div>
            </div>
        );
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js